import React from 'react'
import {Button} from "antd";

const RecipeEdit = ({recipe}) => {

    return(
        <React.Fragment>
                <Button  type={'link'}>
                    <a target={'_blank'} rel="noopener noreferrer" href={`recipe/update/${recipe.id}`}>Güncelle</a>
                </Button>
        </React.Fragment>
    )
}
export default RecipeEdit